import React from 'react';
import { version } from '../package.json';
import App from './containers/App';
import './index.css';
import './i18n';
import { initTelemetry } from './telemetry/datadog_tracer';
import { createRoot } from 'react-dom/client';
import { ApolloProvider } from '@apollo/client';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { theme } from './themes/worktango_theme';
import { ReduxProvider } from './redux/ReduxProvider';
import { store } from './redux/store';
import { apolloClient } from './api';
import querystring from 'querystring';
import { setLanguageISO } from './redux/actions';

// Initialize telemetry (e.g. Datadog)
initTelemetry();

// Grab query param values to initialize app state.
// 1st part of locations is "?"
const { lang } = querystring.parse(window.location.search.slice(1));

store.dispatch(setLanguageISO(lang));

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <ReduxProvider store={store}>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <ApolloProvider client={apolloClient}>
          <App />
        </ApolloProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  </ReduxProvider>,
);

console.log(`version ${version}`);
